import { inject, Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ValidationMessageResolver } from '@ngx-strakit/validation';

@Injectable()
export class SkMaxValidationMessageResolver implements ValidationMessageResolver<{ max: unknown }> {
  private readonly translate = inject(TranslateService);
  readonly errorCode = Validators.max.name;

  getMessage(error?: { max: unknown }): string {
    return this.translate.instant('label.validation.max', { value: error?.max });
  }
}
